const CONTEXT  = "@grid/drop";

function handleDrop(el, binding) {

    const _layoutMan = binding.value;

    const _handle = e => {

        const _dragContext = _layoutMan.Context.get("DragContext");

        if (_dragContext) {

            const _position = _layoutMan.Context.get("MousePosition");

            const _startPoint = _dragContext.StartPoint;

            _layoutMan.GetSelectedList().forEach(config => {

                const _childPositionInfo = config.GetPositionInfo();

                config.SetPositionInfo({
                    Row: _childPositionInfo.Row + (_position.Row - _startPoint.Row),
                    Column: _childPositionInfo.Column + (_position.Column - _startPoint.Column)
                });

            });
            
        }

    };

    if (!el[CONTEXT]) {
        el[CONTEXT] = {
            removeHandle: _handle
        };
    } else {
        el[CONTEXT].removeHandle = _handle;
    }

    return _handle;
}

export default {
    bind(el, binding, vnode) {
        el.addEventListener("mouseup", handleDrop(el, binding));
    },
    update(el, binding) {
        el.removeEventListener("mouseup", el[CONTEXT].removeHandle);
        el.addEventListener("mouseup", handleDrop(el, binding));
    },
    unbind(el, binding) {
        el.removeEventListener("mouseup", handleDrop(el, binding));
    }
};